import { AsyncState } from "widgets-for-react";

export const hasValue =
  <A>(asyncState: AsyncState<A>): asyncState is AsyncState<A> & { kind: 'loaded' | 'loading' } =>
    asyncState.kind == 'loaded' || (asyncState.kind == 'loading' && !!asyncState.value)

export const previousOrDefault = <A>(asyncState: AsyncState<A>, defaultValue: A) =>
  hasValue(asyncState) ? asyncState.value : defaultValue

export const previousOrNull = <A>(asyncState: AsyncState<A>) => hasValue(asyncState) ? asyncState.value : null
